import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: (resolve) => require(['@/views/login'], resolve),
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: (resolve) => require(['@/views/login'], resolve),
    },
    {
      path: '/bindphone',
      name: 'bindphone',
      component: (resolve) => require(['@/views/bindphone'], resolve),
    },

    {
      path: '/agreement',
      name: 'agreement',
      component: (resolve) => require(['@/views/components/agreement'],resolve),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: (resolve) => require(['@/views/components/privacy'],resolve),
    },

    {
      path: '/personal',
      name: 'personal',
      component: (resolve) => require(['@/views/realname/createAccount/personal'],resolve),
    },

    {
      path: '/company',
      name: 'company',
      component: (resolve) => require(['@/views/realname/createAccount/company'],resolve),
    },

    {
      path: '/publicpay',
      name: 'publicpay',
      component: (resolve) => require(['@/views/realname/createAccount/company/publicpay'],resolve),
    },

    {
      path: '/verify',
      name: 'verify',
      component: (resolve) => require(['@/views/realname/createAccount/company/verify'],resolve),
    },
    {
      path: '/wx',
      name: 'wx',
      component: (resolve) => require(['@/views/realname/wx'],resolve),
    },
    {
      path: '/createchoice',
      name: 'createchoice',
      component: (resolve) => require(['@/views/realname/createAccount/company/choice'],resolve),
    },

    {
      path: '/verify-result',
      name: 'verify-result',
      component: (resolve) => require(['@/views/realname/result-verify'],resolve),
    },
    {
      path: '/verifyresult',
      name: 'verifyresult',
      component: (resolve) => require(['@/views/realname/verifyresult'],resolve),
    },


    {
      path: '/author',
      name: 'author',
      component: (resolve) => require(['@/views/realname/author'],resolve),
    },
    {
      path: '/authresult',
      name: 'authresult',
      component: (resolve) => require(['@/views/components/auth-result'],resolve),
    },

    {
      path: '/invalid',
      name: 'invalid',
      component: (resolve) => require(['@/views/invalid'],resolve),
    },

    //  签署模块
    {
      path: '/signin',
      name: 'signin',
      component: (resolve) => require(['@/views/signin'], resolve),
    },
    {
      path: '/waitme',
      name: 'waitme',
      component: (resolve) => require(['@/views/signfile/waitme'], resolve),
    },
    {
      path: '/personalSignature',
      name: 'personalSignature',
      component: (resolve) => require(['@/views/signfile/personalSignature'], resolve),
    },
    {
      path: '/drawsign',
      name: 'drawsign',
      component: (resolve) => require(['@/views/signfile/drawsign'], resolve),
    },
    {
      path: '/drawresult',
      name: 'drawresult',
      component: (resolve) => require(['@/views/signfile/drawsign/drawresult'], resolve),
    },
    {
      path: '/detail',
      name: 'detail',
      component: (resolve) => require(['@/views/signfile/detail'], resolve),
    },
    {
      path: '/contractview',
      name: 'contractview',
      component: (resolve) => require(['@/views/signfile/contractview'], resolve),
    },
    {
      path: '/contractedit',
      name: 'contractedit',
      component: (resolve) => require(['@/views/signfile/edit'], resolve),
    },
    {
      path: '/refuseresult',
      name: 'refuseresult',
      component: (resolve) => require(['@/views/signfile/waitme/refuse-result'], resolve),
    },
    {
      path: '/recall',
      name: 'recall',
      component: (resolve) => require(['@/views/signfile/waitme/recall'], resolve),
    },

    {
      path: '/signauthor',
      name: 'signauthor',
      component: (resolve) => require(['@/views/signfile/author'], resolve),
    },

    {
      path: '/authorsign',
      name: 'authorsign',
      component: (resolve) => require(['@/views/components/authorsign'], resolve),
    },
    {
      path: '/realsignper',
      name: 'realsignper',
      component: (resolve) => require(['@/views/signfile/waitme/realname/personal'], resolve),
    },
    {
      path: '/realsignver',
      name: 'realsignver',
      component: (resolve) => require(['@/views/signfile/waitme/realname/company/verify'], resolve),
    },
    {
      path: '/choice',
      name: 'choice',
      component: (resolve) => require(['@/views/signfile/waitme/realname/company/choice'], resolve),
    },
    {
      path: '/realsigncom',
      name: 'realsigncom',
      component: (resolve) => require(['@/views/signfile/waitme/realname/company'], resolve),
    },
    {
      path: '/realsignpay',
      name: 'realsignpay',
      component: (resolve) => require(['@/views/signfile/waitme/realname/company/publicpay'],resolve),
    },
  ]
})

const zoomPage = ["waitme","detail"];
const scale = 3;
console.log(router.beforeEach)
router.beforeEach((to,from,next)=>{
  console.log(to.name)
  // 获取viewport元标签（提取为公共变量避免重复查询）
  const metaViewport = document.querySelector('meta[name="viewport"]');
  if (metaViewport) {
    // 检查路由名称是否存在且需要缩放
    if (to.name && zoomPage.includes(to.name)) {
      metaViewport.setAttribute('content', `width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=3.0, user-scalable=yes`);
    } else {
      metaViewport.setAttribute('content', `width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no`);
    }
  }
  // 必须调用next()才能继续路由导航（关键修复）
  next();
})


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js